var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.184,
    height: 15.014,
    viewBox: "0 0 24.184 15.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106723",
    "data-name": "Group 106723",
    transform: "translate(-2786.143 -4472.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49506",
    "data-name": "Path 49506",
    d: "M2801.016,4481.057a7.414,7.414,0,0,1-.739,2.392,7.3,7.3,0,0,1-1.758,2.245l-.267.233v0a.2.2,0,0,1-.1.144,7.7,7.7,0,0,1-1.876,1.036,7.241,7.241,0,0,1-2.055.459,7.549,7.549,0,0,1-7.721-5.05,5.954,5.954,0,0,1-.293-1.146,6.9,6.9,0,0,1-.049-.765c0-.044.013-.089-.012-.131v-.855c.025-.192.024-.387.032-.581a4.586,4.586,0,0,1,.2-1.052,7.439,7.439,0,0,1,1.02-2.179,7.972,7.972,0,0,1,1.309-1.458,7.057,7.057,0,0,1,1.546-1.037,6.982,6.982,0,0,1,2.057-.675,5.248,5.248,0,0,1,.813-.049c.023,0,.049.007.07-.012h.856c.2.024.4.022.592.033a5.548,5.548,0,0,1,1.514.346,7.369,7.369,0,0,1,1.812.94,1.208,1.208,0,0,1,.3.258.083.083,0,0,1,0,.039l-.006.011a7.263,7.263,0,0,1,1.433,1.508,7.461,7.461,0,0,1,1.323,5.344Z",
    transform: "translate(0 -0.07)",
    fill: "#fe5a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49507",
    "data-name": "Path 49507",
    d: "M3280.62,4474.119a.064.064,0,0,0,0-.015c-.007-.067.039-.1.085-.137a7.215,7.215,0,0,1,.878-.571,7.309,7.309,0,0,1,2.225-.81,6.925,6.925,0,0,1,.81-.067.767.767,0,0,0,.217-.012h.684c.05,0,.091,0,.12,0s.062,0,.075.007l.052.006a7.071,7.071,0,0,1,2.376.515,7.258,7.258,0,0,1,2.022,1.261,7.53,7.53,0,0,1,2.331,3.667,5.33,5.33,0,0,1,.2,1.381c0,.02,0,.042.012.058v1.076c-.023.229-.024.46-.045.69a5.646,5.646,0,0,1-.331,1.36,7.488,7.488,0,0,1-1.586,2.6,7.58,7.58,0,0,1-1.9,1.478,7.441,7.441,0,0,1-1.924.728,7.81,7.81,0,0,1-1.377.178,7.421,7.421,0,0,1-2.977-.479,7.326,7.326,0,0,1-1.824-1c-.056-.042-.134-.073-.125-.166a.238.238,0,0,1,.111-.167,7.372,7.372,0,0,0,2.595-4.592,6.949,6.949,0,0,0,.081-1.447,7.507,7.507,0,0,0-1.213-3.741,7.713,7.713,0,0,0-1.492-1.667C3280.656,4474.213,3280.612,4474.182,3280.62,4474.119Z",
    transform: "translate(-482.378)",
    fill: "#f69d1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.4fa20cbc9de6a70b010cee9f39f15005.svg";
export { ForwardRef as ReactComponent };